<template>
  <div
    v-if="visible"
    class="fixed top-0 left-0 w-full bg-black text-primary-500 z-50"
    role="region"
    aria-label="Information de résolution de bug"
  >
    <div
      class="max-w-screen-xl mx-auto px-4 py-3 flex items-center justify-between"
    >
      <span class="font-bold">
        {{ currentBug?.message }}
      </span>

      <button
        @click="closeBanner"
        aria-label="Fermer l'annonce"
        class="ml-4 p-1 rounded hover:opacity-80 focus:outline-none focus:ring focus:ring-yellow-400/40"
      >
        <!-- Croix jaune -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 8.586l4.95-4.95a1 1 0 111.414 1.414L11.414 10l4.95 4.95a1 1 0 11-1.414 1.414L10 11.414l-4.95 4.95a1 1 0 11-1.414-1.414L8.586 10l-4.95-4.95A1 1 0 115.05 3.636L10 8.586z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Storage from '@/shared/utils/storage.js'
import bugs from './bugs.json'

const BUG_STORAGE_KEY = 'closed_bugs'

const visible = ref(false)
const currentBug = ref(null)

/** Vérifie si la date du bug correspond à aujourd’hui ou demain */
function isBugActive(bugDate) {
  const bugDay = new Date(bugDate)
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)

  // Supprime l'heure pour ne comparer que le jour
  bugDay.setHours(0, 0, 0, 0)
  today.setHours(0, 0, 0, 0)
  yesterday.setHours(0, 0, 0, 0)

  return (
    bugDay.getTime() === today.getTime() ||
    bugDay.getTime() === yesterday.getTime()
  )
}

/** Charge ./bugs.json et affiche la bannière si le bug est actif */
function loadBugs() {
  if (!Array.isArray(bugs) || bugs.length === 0) return

  // Prend le plus récent
  const latest = bugs[0]
  if (!isBugActive(latest.date)) return

  const closedBugs = Storage.get(BUG_STORAGE_KEY) || {}
  const closedAt = closedBugs[latest.id]

  if (!closedAt) {
    currentBug.value = latest
    visible.value = true
  }
}

function closeBanner() {
  if (currentBug.value?.id) {
    const closedBugs = Storage.get(BUG_STORAGE_KEY) || {}
    closedBugs[currentBug.value.id] = Date.now()
    Storage.save(BUG_STORAGE_KEY, closedBugs)
  }
  visible.value = false
}

onMounted(loadBugs)
</script>
